<template>
  <div>
    
    <!-- Emergency Create And Update Modal START -->
    <v-dialog persistent v-model="rescueModal" max-width="1000">
      <v-card>
        <v-card-title class="headline indigo lighten-2">
          <div class="text-center white--text" style="width: 100%">
            {{
              $t("buttons.setRescueTeam")
            }}
          </div>
        </v-card-title>
        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
          <form @submit.prevent="handleSubmit(updateUser())">
            <v-card-text class="pt-4 text-center d-flex justify-center">
              <div class="text-center" style="width: 100% !important">
                <!-- Group start -->
                <v-card-text
                  class="px-0 my-0 add-content-card-body"
                >
                  <v-banner rounded outlined>
                    <v-card-title class="add-content-title my-0">
                      {{ $t("labels.postGroup") }}
                    </v-card-title>

                    <v-row align="center">
                    <v-col cols="12">
                      <v-select
                        :items="rescueTeams"
                        v-model="selectedTeam"
                        item-text="TeamName"
                        item-value="Id"
                        :menu-props="{ top: true, offsetY: true }"
                        label="Kurtarma Ekibi"
                      ></v-select>
                    </v-col>
                  </v-row>
                    
                  </v-banner>
                </v-card-text>
                <!-- Groups end -->
                
                

                <v-btn
                  small
                  class="ma-2 mr-4"
                  type="submit"
                  elevation="0"
                  large
                  outlined
                  color="green"
                >
                {{
              $t("buttons.setRescueTeam")
            }}
                </v-btn>
                <v-btn
                  small
                  class="ma-2 mr-4"
                  elevation="0"
                  large
                  outlined
                  color="grey"
                  @click="rescueModal = false"
                >
                  {{ $t("buttons.cancel") }}
                </v-btn>
              </div>
            </v-card-text>
          </form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <!-- Emergency Create And Update Modal END -->
    <!-- Alert PopUp -->
    <v-dialog v-model="endEmergencyModal" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">
          {{ $t("buttons.stopEmergency") }}
        </v-card-title>
        <v-card-text>
          {{ $t("description.stopEmergency") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="updateEmergency()">
            {{ $t("buttons.yes") }}
          </v-btn>
          <v-btn color="green darken-1" text @click="endEmergencyModal = false">
            {{ $t("buttons.no") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- List Of People -->
    <v-dialog v-model="showPeopleDialog" max-width="1000" >
      <v-card>
        <v-card-title class="headline">
          Kişi Listesi
        </v-card-title>
        <v-card-actions>
          <ul>
            <li
              :key="index"
              v-for="(item, index) in activeUsers"
              style="margin-bottom: 1vh;"
            >
              <p v-if="item.SafetyStatus == 0">
                {{ item.Name }} - {{ item.Username }} - {{ item.Phone }} - {{ item.Address }} - 
                <span class="green--text font-weight-bold">Güvende</span> -
                <a :href="item.MapLink" target="_blank">Konum Bilgisi Göster</a>
              </p>
              <p v-if="item.SafetyStatus == 1">
                {{ item.Name }} - {{ item.Username }} - {{ item.Phone }} - {{ item.Address }} -
                <span class="error--text font-weight-bold">Güvende Değil</span> -
                <a :href="item.MapLink" target="_blank">Konum Bilgisi Göster</a>
              </p>
              <!-- <p v-if="item.SafetyStatus == 2">
                {{ item.Name }} - {{ item.Username }} - {{ item.Phone }} - {{ item.Address }} -
                <span class="error--text font-weight-bold">Ihtiyaç Sahibi</span> -
                <a :href="item.MapLink" target="_blank">Konum Bilgisi Göster</a>
              </p> -->
              
            </li>
          </ul>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Marker Popup -->
    <v-dialog v-model="markerModalShow" max-width="400">
      <v-card class="mx-auto" max-width="400" outlined>
        <v-list-item three-line>
          <v-list-item-content>
            <div
              :class="
                `mb-4 ${getTitleColor(
                  selectedMarker
                )}--text text-h5 font-weight-bold`
              "
            >
              {{
                selectedMarker.SafetyStatus === 0
                  ? $t("labels.successEmergency")
                  :selectedMarker.SafetyStatus===1? $t("labels.alertEmergency")
                  : $t("labels.needy")
              }}
            </div>
            <v-list-item-title class="text-h5 mb-1">
              {{ selectedMarker.Name }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-h6 mb-1">{{
              selectedMarker.Username
            }}</v-list-item-subtitle>
            <v-list-item-subtitle class="text-h6 mb-1">{{
              selectedMarker.Phone
            }}</v-list-item-subtitle>
            <v-list-item-subtitle class="text-h6 mb-1 wrap-text">{{
              selectedMarker.Address
            }}</v-list-item-subtitle>
            <v-list-item-subtitle class="text-h6 font-weight-bold">
              <a :href="selectedMarker.MapLink" target="_blank"
                >Konum Bilgisi Göster</a
              >
            </v-list-item-subtitle>
          </v-list-item-content>

          <!-- <v-list-item-avatar tile size="80">
            <v-img :src="selectedMarker.Avatar"></v-img>
          </v-list-item-avatar> -->
        </v-list-item>

        <v-card-actions class="text-center justify-center">
          <v-btn outlined rounded text @click="markerModalShow = false">
            {{ $t("buttons.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Main page content -->
    <v-card style="border-radius: 10px">
      <v-card-title style="color: #595959">
        <v-row align="center">
          <v-col>
            <v-btn
              class="ma-2 mr-4"
              elevation="0"
              outlined
              color="default"
              @click="goBack()"
            >
              <v-icon aria-hidden="false">
                mdi-arrow-left
              </v-icon>
            </v-btn>
          </v-col>
          <v-spacer />
          <v-col cols="auto" align="end" v-if="status !== 2">
            <v-btn
              small
              class="ma-2 mr-4"
              elevation="0"
              outlined
              color="default"
              @click="endEmergencyModal = true"
            >
              {{ $t("buttons.stopEmergency") }}
            </v-btn>
            <v-btn
              v-if="filterStatus !== null"
              small
              class="ma-2 mr-4"
              elevation="0"
              outlined
              color="default"
              @click="getEmergencyDetail(); getEventItems()"
            >
              {{ $t("buttons.clearFilter") }}
            </v-btn>
            <v-btn
              small
              class="ma-2 mr-4"
              elevation="0"
              outlined
              color="default"
              @click="getEmergencyDetail(); getEventItems(filterStatus)"
            >
              {{ $t("buttons.refresh") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-divider />

      <v-card-text v-if="status !== 2" class="pt-4 mb-10">
        <div style="width:100%">
          <div
            :class="`text-center font-weight-bold text-h3 ${status === 0 ? 'blinkText error--text' : ''} mb-7`"
          >
            {{ $t(`titles.${emergency.EventType === 0 ? 'emergency' : 'drill'}Title`, {value: $t(statusTitle)}) }}
          </div>
          <div class="blue-grey--text font-weight-bold text-h4 mb-2">
            {{ title }}
          </div>
          <div class="blue-grey--text font-weight-medium text-h6 mb-1">
            {{ description }}
          </div>
          <div
            class="text-right error--text font-weight-bold text-h5"
            @click="getEventItems(1)"
            style="cursor: pointer;"
          >
            Güvende Olmayan Kişi Sayısı : {{ personInDanger.length }}
          </div>
          <div
            class="text-right green--text font-weight-bold text-h5"
            @click="getEventItems(0)"
            style="cursor: pointer;"
          >
            Güvende Olan Kişi Sayısı : {{ personNotInDanger.length }}
          </div>
        </div>
        <div class="mb-10 mt-5">
          <google-map
            :center="{ lat: 39.925533, lng: 32.866287 }"
            :zoom="6"
            style="width:100%; height: 500px;"
          >
            <google-map-cluster
              :minimumClusterSize="2"
              @click="getDetailFromCluster($event)"
              :styles="clusterStyles"
            >
              <google-map-marker
                :key="index"
                v-for="(item, index) in eventItemsFiltered"
                :options="{
                  streetViewControl: false,
                }"
                :position="{ lat: item.Latitude, lng: item.Longitude }"
                :clickable="true"
                :draggable="false"
                :icon="{
                  url: getMarkerIcon(item),
                  size: { width: 30, height: 30, f: 'px', b: 'px' },
                  scaledSize: { width: 30, height: 30, f: 'px', b: 'px' },
                }"
                @click="openMarkerInfo(item)"
                style="width:20px; height:20px"
              />
              <google-map-info-window></google-map-info-window>
            </google-map-cluster>
          </google-map>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import EmergencyService from "../services/EmergencyService";
import GroupService from "../services/GroupService";
import RescueTeamService from "../services/RescueTeamService";

export default {
  data: () => ({
    //-1: Oluşturulabilir
    //0: Oluşturuldu - Onay Bekliyor
    //1: Onaylandı
    //2: Silindi
    status: -2,
    emergency: null,

    clusterStyles: [
      {
        url: require("../../public/img/m1.png"),
        textColor: "white",
        width: 53,
        height: 52,
        anchorText: [0.5, 0.5],
        fontWeight: "bold",
        fontFamily: "Arial",
        textSize: 15,
      },
      {
        url: require("../../public/img/m2.png"),
        textColor: "white",
        width: 56,
        height: 55,
        fontWeight: "bold",
        fontFamily: "Arial",
        textSize: 15,
      },
      {
        url: require("../../public/img/m3.png"),
        textColor: "white",
        width: 66,
        height: 65,
        fontWeight: "bold",
        fontFamily: "Arial",
        textSize: 15,
      },
      {
        url: require("../../public/img/m4.png"),
        textColor: "white",
        width: 78,
        height: 77,
        fontWeight: "bold",
        fontFamily: "Arial",
        textSize: 15,
      },
      {
        url: require("../../public/img/m5.png"),
        textColor: "white",
        width: 90,
        height: 89,
        fontWeight: "bold",
        fontFamily: "Arial",
        textSize: 15,
      },
    ],

    //RescueTeam
    rescueModal: false,
    selectedTeam:"",
    updateId:null,
    // Filter Status For Filtering People
    filterStatus: null,

    // Zoom
    zoom: 6,

    //Form
    title: "",
    description: "",
    createdBy: null,

    //Emergency Object
    eventId: "",
    eventItems: [],
    rescueTeams:[],
    eventItemsFiltered: [],

    //Map
    selectedMarker: {},
    markerModalShow: false,

    // PeopleDialog
    showPeopleDialog: false,
    activeUsers: [],

    //AlertDialog
    endEmergencyModal: false,

    //Group
    selecItems: [],
    groupData: [],
    groupLengthAlert: false,
    groupArr: [[]],
    groupsSelectArray: [],
    corpGroup: [],
    locGroup: [],
    empGroup: [],
    allSelect: [],
    teamModel: [],
    showGroup: true,
  }),
  computed: {

    statusTitle(){
      return `titles.${this.status === 0 ? 'active' : this.status === 1 ? 'paused' : this.status === -1 ? 'alarm' : '' }`;
    },

    personInDanger() {
      return this.eventItems.filter((x) => x.SafetyStatus === 1);
    },
    personNotInDanger() {
      return this.eventItems.filter((x) => x.SafetyStatus === 0);
    },
    personNeedy() {
      return this.eventItems.filter((x) => x.SafetyStatus === 2);
    },
  },
  watch: {},
  mounted() {
    this.getEmergencyDetail();
  },
  components: {},
  methods: {
    getRescueTeams(){
      this.$store.state.loadingStatus = true;
      RescueTeamService.getTeams(1,100)
        .then((res) => {
          this.rescueTeams=res.data.Result;
          
        })
        .catch((err) => {
          window.showError(err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    getDetailFromCluster(e) {
      this.activeUsers = [];
      e.markers_.forEach((item) => {
        if (
          this.activeUsers.findIndex(
            (user) =>
              user.Latitude === item.position.lat() &&
              user.Longitude === item.position.lng()
          ) < 0
        ) {
          var activeUser = this.eventItemsFiltered.filter(
            (user) =>
              user.Latitude === item.position.lat() &&
              user.Longitude === item.position.lng()
          );
          if (activeUser.length > 1) {
            activeUser.forEach((user) => this.activeUsers.push(user));
          } else if (activeUser.length > 0) {
            this.activeUsers.push(activeUser[0]);
          }
        }
      });
      this.showPeopleDialog = true;
      console.log("ACTIVE USERS >> ", this.activeUsers);
    },

    /**
     * Go to back in navigation's history.
     * @returns {void}
     */
    goBack() {
      this.$router.go(-1);
    },

    async getEmergencyDetail() {
      this.eventId = this.$route.params.id;
      if (this.eventId) {
        EmergencyService.getEventDataById(this.eventId)
        .then(response => {
          const data = response?.data?.Result;
          if(data && data.EventStatus !== 2){
            this.emergency = data;
            this.status = data.EventStatus;
            this.title = data.Title;
            this.description = data.Description;
            this.createdBy = data.CreateBy;
            this.showGroup = false;

            if (data.EventStatus === 0) {
              this.getEventItems();
            }
          }
          else{
            this.goBack();
          }
        });
      } else {
          this.clearPage();
          this.goBack();
      }
    },
    
    sendEmergencyControl() {
      if (this.title !== "" && this.description !== "") {
        this.createGroupIds();
      } else {
        window.showInfo(
          this.$t("description.errorOnCreate"),
          "standart",
          "error"
        );
      }
    },

    getButtonText() {
      switch (this.status) {
        case -1:
          return this.$t("buttons.sendEmergency");
        case 0:
          return this.$t("buttons.approvalEmergency");
        default:
          return this.$t("buttons.sendEmergency");
      }
    },
    clickGroupFilterModal(element, colIndex, dataIndex) {
      if (
        element.type == "lokasyon" &&
        this.groupArr[dataIndex][colIndex - 1] == undefined
      ) {
        this.groupsSelectArray[dataIndex][colIndex].groups = [...[]];
      }
      if (
        (element.type == "lokasyon" &&
          this.groupArr[dataIndex][colIndex - 1] != undefined) ||
        element.type == "calisan_tipi" ||
        element.type == "sirket"
      ) {
        GroupService.getGroups(
          element.type,
          element.type == "lokasyon"
            ? this.groupArr[dataIndex][colIndex - 1]
            : ""
        )
          .then((res) => {
            let arr = [];
            if (element.type != "calisan_tipi") {
              res.data.forEach((item) => {
                let obj = {
                  id: item.Id,
                  name: item.Name,
                };
                arr.push(obj);
              });
            }
            if (
              element.type != "sirket" ||
              this.$store.getters.getPermissionIds
            )
              arr.unshift({ name: "Tümü", id: "All" });
            this.groupsSelectArray[dataIndex][colIndex].groups = arr;
            let listObj = {
              Type: element.type,
              Data: arr,
            };
            this.selecItems.push(listObj);
          })
          .catch((err) => {
            window.showError(err);
          })
          .then(() => {});
      }
    },
    getGroupTypesModal() {
      GroupService.getGroupTypes()
        .then((res) => {
          res.data.forEach((element) => {
            let obj = {
              type: element.Code,
              groups: [],
              name: element.Name,
            };

            this.groupData.push(obj);
          });
          this.groupsSelectArray.push(this.groupData);
        })
        .catch((err) => {
          window.showError(err);
        });
    },
    updateUser(){
      let body = {
        TeamId:this.selectedTeam,
        UserId:this.updateId
      };
      this.$store.state.loadingStatus = true;
      EmergencyServices.setRescueTeam(body)
        .then((res) => {
          this.eventItemsFiltered.find(
            (x) => x.Id == this.updateId
          ).RescueTeam=this.selectedTeam;
          this.clearModal();
          window.showInfo(
            this.$t("description.successSetRescueTeam"),
            "standart",
            "info"
          );
          
        })
        .catch((err) => {
          window.showError(err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    changeGroupInput(element, colIndex, dataIndex) {
      if (element.type == "sirket") {
        this.groupArr[dataIndex][colIndex + 1] = "";
      }
    },
    openRescueModal(item){
      this.rescueModal=true;
      this.updateId=item.Id;
    },
    setRescueTeam(){
      if (this.title !== "" && this.description !== "") {
        this.createGroupIds();
      } else {
        window.showInfo(
          this.$t("description.errorOnCreate"),
          "standart",
          "error"
        );
      }
    },

    updateEmergency(status = 2) {
      let body = {
        Title: this.title,
        Description: this.description,
        EventStatus: status,
        EventId: this.eventId,
      };
      console.log("BODY UPDATE EMERGENCY SHUTDOWN >> ", body);
      this.$store.state.loadingStatus = true;
      EmergencyService.updateEvent(body)
        .then((res) => {
          this.clearPage();
          this.goBack();
        })
        .catch(window.showError)
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    async getEventItems(filterStatus = null) {
      this.filterStatus = filterStatus;
      this.$store.state.loadingStatus = true;
      EmergencyService.getEventById({EventId: this.eventId, SafetyStatus: filterStatus})
        .then((res) => {
          res.data.forEach((element) => {
            element.Latitude = parseFloat(element.Latitude);
            element.Longitude = parseFloat(element.Longitude);
          });
          this.eventItemsFiltered = res.data;
        })
        .catch((err) => {
          window.showError(err);
        });

      EmergencyService.getEventById({ EventId: this.eventId })
        .then((res) => {
          res.data.forEach((element) => {
            element.Latitude = parseFloat(element.Latitude);
            element.Longitude = parseFloat(element.Longitude);
          });
          this.eventItems = res.data;
        })
        .catch((err) => {
          window.showError(err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    getMarkerIcon(item) {
      if (item.SafetyStatus === 1)
        return require("../../public/img/PersonInDanger.png");
      else if(item.SafetyStatus === 0) {
        return require("../../public/img/PersonNotInDanger.png");
      }else{
        return require("../../public/img/needyIcon.png");
      }
    },

    openMarkerInfo(item) {
      this.selectedMarker = item;
      this.markerModalShow = true;
    },

    getTitleColor(item) {
      if (item.SafetyStatus === 0) return "green";
      else if(item.SafetyStatus === 1) {
        return "error";
      }else{
        return "orange";
      }
    },

    clearPage() {
      this.status = -1;
      this.title = "";
      this.description = "";
      this.createdBy = null;
      this.eventId = "";
      this.eventItems = [];
      this.selectedMarker = {};
      this.markerModalShow = false;
      this.rescueModal = false;
      this.endEmergencyModal = false;
    },
    clearModal() {
      this.teamModel=[];
      this.rescueModal=false;
    },
  },
};
</script>

<style>
.blinkText {
  animation: blink 1.2s linear infinite !important;
}
.wrap-text {
  -webkit-line-clamp: unset !important;
}

@keyframes blink {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
